import { render, staticRenderFns } from "./FormLv2.vue?vue&type=template&id=4a0bf0a0&scoped=true"
import script from "./FormLv2.vue?vue&type=script&lang=js"
export * from "./FormLv2.vue?vue&type=script&lang=js"
import style0 from "./FormLv2.vue?vue&type=style&index=0&id=4a0bf0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bf0a0",
  null
  
)

export default component.exports